// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--1zG-R","pointer-icon":"dd31006766--pointer-icon--3MAak"};